import { FaFacebookF, FaInstagram, FaYoutube, FaRss, FaWhatsapp, FaGooglePlay, FaApple } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiThreads } from "react-icons/si";
import { cn } from "@/lib/utils";

// Arattai icon component using actual logo image
const ArattaiIcon = ({ size = 16 }: { size?: number; color?: string }) => (
  <img
    src="https://media.dinamani.com/dinamani/2026-02-25/gjt6ao2j/Arattailogo.png"
    alt="Arattai"
    width={size}
    height={size}
    className="rounded-sm"
    style={{ objectFit: 'contain' }}
  />
);

type SocialIconProps = {
  className?: string;
  useGrid?: boolean;
  showAppIcons?: boolean;
};

const SocialIcons = ({ className, useGrid = false, showAppIcons = true }: SocialIconProps) => {
  const allSocialLinks = [
    { icon: <FaFacebookF size={16} color={useGrid ? "#3B5998" : "#FFFFFF"} />, href: "https://www.facebook.com/DinamaniDaily", label: "Facebook", bgColor: "#3B5998" },
    { icon: <ArattaiIcon size={24} />, href: "https://aratt.ai/@dinamani", label: "Arattai", bgColor: "#FFC107", isImage: true },
    { icon: <FaInstagram size={16} color={useGrid ? "#D62976" : "#FFFFFF"} />, href: "https://www.instagram.com/dinamanidaily/", label: "Instagram", bgColor: "#D62976" },
    { icon: <FaXTwitter size={16} color={useGrid ? "#000000" : "#FFFFFF"} />, href: "https://x.com/DinamaniDaily", label: "X", bgColor: "#000000" },
    { icon: <FaYoutube size={16} color={useGrid ? "#FF0200" : "#FFFFFF"} />, href: "https://www.youtube.com/channel/UC3jcdpf8dWtljex9PyhSM6w", label: "YouTube", bgColor: "#FF0200" },
    // { icon: <FaRss size={16} color={useGrid ? "#EE802F" : "#FFFFFF"} />, href: "#rss", label: "RSS", bgColor: "#EE802F" },
    { icon: <FaWhatsapp size={16} color={useGrid ? "#67C15E" : "#FFFFFF"} />, href: "https://www.whatsapp.com/channel/0029Va60JxGFcowBIEtwvB0G", label: "WhatsApp", bgColor: "#67C15E" },
    { icon: <FaGooglePlay size={16} color={useGrid ? "#A4C639" : "#FFFFFF"} />, href: "https://play.google.com/store/apps/details?id=com.dinamani.android", label: "Play Store", bgColor: "#A4C639" },
    { icon: <FaApple size={16} color={useGrid ? "#000000" : "#FFFFFF"} />, href: "https://apps.apple.com/app/dinamani-tamil-news/id1244532821", label: "Apple", bgColor: "#000000" },
  ];

  const socialLinks = showAppIcons
    ? allSocialLinks
    : allSocialLinks.filter(link => link.label !== "Play Store" && link.label !== "Apple");

  return (
    <ul className={cn(
      useGrid
        ? "flex flex-wrap items-center gap-3"
        : "flex flex-wrap items-center gap-3",
      className
    )}>
      {socialLinks.map((item: any, index) => (
        <li key={index}>
          <a
            href={item.href}
            target="_blank"
            rel="noreferrer"
            aria-label={item.label}
            className={cn(
              "inline-flex items-center justify-center shadow-sm hover:shadow transition-all",
              item.isImage
                ? "w-6 h-6 rounded-md overflow-hidden"
                : `w-6 h-6 rounded-full ${useGrid ? 'bg-FFFFFF border border-DCDCDC' : ''}`
            )}
            style={!useGrid ? { backgroundColor: item.bgColor } : {}}
          >
            {item.icon}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialIcons;
